import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

import Vue from 'vue'
import '@/element-ui' // api: https://github.com/ElemeFE/element
// import elementUI from 'element-ui'  // api: https://github.com/ElemeFE/element
import '@/icons' // api: http://www.iconfont.cn/
import '@/element-ui-theme'
import '@/assets/scss/index.scss'
import 'element-ui/lib/theme-chalk/index.css'
import App from '@/App'
import router from '@/router' // api: https://github.com/vuejs/vue-router
import store from '@/store' // api: https://github.com/vuejs/vuex
import VueCookie from 'vue-cookie' // api: https://github.com/alfhen/vue-cookie
import httpRequest from '@/utils/httpRequest' // api: https://github.com/axios/axios
import {tabsCloseAllHandle, tabsCloseCurrentHandle, tabsRefreshCurrentHandle,removeTabHandle} from '@/utils/routeTab'
import myUi from './components/index';
import './svg/index.js';
import {
    addMonth,
    formatDate,
    formatterDataDictionary,
    getCookie,
    formatterTagType,
    getFullMonth,
    getMonth,
    getYear,
    iframeInsert,
    isIEBrowser,
    parseToDate,
    formatDataState,
    formatEntStatus,
    rgbaFn,
    leftMenuFn

} from '@/utils'
import {initMenuList} from '@/router/index'
import { message } from '@/utils/resetMessage'
import { hasBtnPermission, isAuth } from '@/utils/login'
import cloneDeep from 'lodash/cloneDeep'
import flowChart from '@/components/flowChart'
import rightNav from '@/components/componentNav'
import choiceCity from '@/components/choiceCity'
import docPop from "@/components/docPop";
import searchBox from '@/components/searchBox/index'//搜索组件
import imgUpload from '@/components/imgUpload/index'//图片上传+OCR识别表单
import imgUploadView from '@/components/imgUploadView/index'//图片上传+OCR识别详情
import { Button, Steps, Icon, Calendar, Badge } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import NavTitle from '@/components/NavTitle'
import Pagination from '@/components/pagination/pagination'


import canvasToPdf from "@/utils/canvasToPdf.js"
canvasToPdf.install(Vue)
Vue.component('nav-title', NavTitle)
Vue.component('pagination', Pagination)
Vue.use(Calendar)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Steps)
Vue.use(Badge)
import moment from 'moment';
import 'moment/locale/zh-cn'; // 获取中国标准时间，避免出现utc时间
Vue.prototype.moment = moment

if(!settings.secondaryDirectory){
    settings.secondaryDirectory=''
}
Vue.prototype.settings=settings;

import * as filters from './filter/index';
import './directives/index'
import md5 from 'js-md5'
const globalGrayTableHeaderStyle = {
    'background-color': '#e3ecfb',
    'font-size': '14px',
    'color': 'rgba(0,0,0,.85)',
    'font-weight': 'bold'
}

Vue.use(myUi);
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
// import vRegion from 'v-region';
// Vue.use(vRegion);



Vue.use(VueCookie)
// Vue.use(elementUI)
Vue.config.productionTip = false
// 非生产环境, 适配mockjs模拟数据                 // api: https://github.com/nuysoft/Mock
if (process.env.NODE_ENV !== 'production') {
    require('@/mock')
}

Vue.component('flowChart', flowChart)
Vue.component('rightNav', rightNav)
Vue.component('choiceCity', choiceCity)
Vue.component('docPop', docPop)
Vue.component("searchBox", searchBox);
Vue.component("imgUpload", imgUpload);
Vue.component("imgUploadView", imgUploadView);

Vue.prototype.$bus = new Vue();
// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.$httpReq = httpRequest // ajax请求方法
Vue.prototype.isAuth = isAuth // 权限方法
Vue.prototype.hasBtnPermission = hasBtnPermission // btn权限方法
Vue.prototype.parseToDate = parseToDate
Vue.prototype.isIEBrowser = isIEBrowser
Vue.prototype.iframeInsert = iframeInsert
Vue.prototype.getMonth = getMonth
Vue.prototype.getYear = getYear
Vue.prototype.formatDate = formatDate
Vue.prototype.addMonth = addMonth
Vue.prototype.getFullMonth = getFullMonth
Vue.prototype.tabsCloseCurrent = tabsCloseCurrentHandle
Vue.prototype.tabsCloseAllHandle = tabsCloseAllHandle
Vue.prototype.tabsRefreshCurrent = tabsRefreshCurrentHandle
Vue.prototype.initMenuList = initMenuList
Vue.prototype.formatterTagType = formatterTagType
Vue.prototype.formatterDataDictionary = formatterDataDictionary
Vue.prototype.$message = message
Vue.prototype.$md5 = md5
Vue.prototype.$globalGrayTableHeaderStyle = globalGrayTableHeaderStyle
Vue.prototype.formatDataState = formatDataState
Vue.prototype.formatEntStatus = formatEntStatus
Vue.prototype.$bigDataUrl = process.env.VUE_APP_bigData
Vue.prototype.rgbaFn = rgbaFn
Vue.prototype.leftMenuFn = leftMenuFn
Vue.prototype.openBidWitness_dataTypeObj ={
    bidOpening:'1',// 开标
    bidEvaluation:'2',//评标
    expertExtraction:'8',// 专家抽取
}
window.removeTabHandle = removeTabHandle
window.tabsCloseCurrentHandle= tabsCloseCurrentHandle
if (!settings.secondaryDirectory) {
    settings.secondaryDirectory = process.env.VUE_APP_proxybaseurl
}
// 保存整站vuex本地储存初始状态
window.SITE_CONFIG['storeState'] = cloneDeep(store.state)
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
